import React, { useEffect, useState, useRef } from 'react';
import { Page, Image, Document, PDFViewer, pdf } from '@react-pdf/renderer';
import Navbar from "../Components/Navbar";
import Access from "../Components/Access";
import { getyears } from "../Components/Tools";
import axios from 'axios';
import qs from 'qs';
import { toPng } from 'html-to-image';
import { ReactComponent as IconPdfWhite } from '../Img/icon-pdf-white.svg';
import { ReactComponent as IconScrollUp } from '../Img/scroll-up.svg';
import BounceLoader from "react-spinners/BounceLoader";
import Page1Accueil from "./Page1Accueil";
import Page2Sommaire from "./Page2Sommaire";
import Page3Fct from "./Page3Fct";
import Page4RestitutionFct from "./Page4RestitutionFct";
import Page5Graph from './Page5Graph';
import Page6Graph from './Page6Graph';
import Page7Graph from './Page7Graph';
import Page8Graph from './Page8Graph';
import Page9Graph from './Page9Graph';
import Page10Inv from "./Page10Inv";
import Page11RestitutionInv from "./Page11RestitutionInv";
import Page12Graph from './Page12Graph';
import Page13Graph from './Page13Graph';
import Page14Fiscalite from './Page14Fiscalite';
import Page15FiscaliteRetro from './Page15FiscaliteRetro';
import Page16Graph from './Page16Graph';
import Page17Graph from './Page17Graph';
import Page18Graph from './Page18Graph';
import Page19Graph from './Page19Graph';
import Page20Graph from './Page20Graph';
import Page21Graph from './Page21Graph';
import Page22Dette from './Page22Dette';
import Page23Graph from './Page23Graph';
import Page24Graph from './Page24Graph';
import Page25Graph from './Page25Graph';
import Page26Graph from './Page26Graph';
import Page31ProjectionFinanciere from './Page31ProjectionFinanciere';
import Page32ComFP from './Page32ComFP';
import Page33RestitutionProsp from './Page33RestitutionProsp';
import Page34FiscaliteProsp from './Page34FiscaliteProsp';
import Page35Graph from './Page35Graph';
import Page36Graph from './Page36Graph';
import Page37Graph from './Page37Graph';
import Page38Graph from './Page38Graph';
import Page39Graph from './Page39Graph';
import Page40Graph from './Page40Graph';
import Page41Graph from './Page41Graph';
import Page42Graph from './Page42Graph';
import Page43Graph from './Page43Graph';
import Page44Graph from './Page44Graph';
import Page45Graph from './Page45Graph';
import Page46Graph from './Page46Graph';
import Page47Graph from './Page47Graph';
import Page48Graph from './Page48Graph';
import Page49Graph from './Page49Graph';


/*  La variable projet contient toutes les infos du projet et est structurée ainsi:
    projet[0] = id
    projet[1] = numero_projet
    projet[2] = nom
    projet[3] = enjeu
    projet[4] = description
    projet[5] = montant
    projet[6] = h1
    projet[7] = h2
    projet[8] = h3
    projet[9] = Dépenses de fonctionnement
    projet[10] = Recettes de fonctionnement
    projet[11] = Dépenses d'investissement
    projet[12] = Recettes d'investissement
*/
const BilanPDF = (props) =>
{
    const green = '#59B44A';
    const purple = '#6571FE';

    const [PDFREADY, setPDFREADY] = useState(false);
    const [aff, setAff] = useState(false);
    const [affRetro, setAffRetro] = useState(true);
    const [affProsp, setAffProsp] = useState(true);
    const [affH1, setAffH1] = useState(true);
    const [affH2, setAffH2] = useState(true);
    const [affH3, setAffH3] = useState(true);
    const [affFP, setAffFP] = useState(true);
    const [clicked, setClicked] = useState(false);
    const [yearsRetro, setYearsRetro] = useState(null);
    const [yearsProsp, setYearsProsp] = useState(null);
    const date = new Date();
    const day = date.getDate()<10?'0'+date.getDate():date.getDate();
    const month = (date.getMonth()+1)<10?'0'+(date.getMonth()+1):(date.getMonth()+1);
    const hour = date.getHours()<10?'0'+date.getHours():date.getHours();
    const minutes = date.getMinutes()<10?'0'+date.getMinutes():date.getMinutes();
    const dateFR = 'Le  '+day+' / '+month+' / '+date.getFullYear()+' à '+hour+':'+minutes;
    const [incid_fin_h1, setIncid_fin_h1] = useState(null);
    const [incid_fin_h2, setIncid_fin_h2] = useState(null);
    const [incid_fin_h3, setIncid_fin_h3] = useState(null);
    const [hypothese1, setHypothese1] = useState({'num': 1, 'nom': '', 'commentaire': ''});
    const [hypothese2, setHypothese2] = useState({'num': 2, 'nom': '', 'commentaire': ''});
    const [hypothese3, setHypothese3] = useState({'num': 3, 'nom': '', 'commentaire': ''});
    const [restitution_fct_h1, setRestitution_fct_h1] = useState(null);
    const [restitution_evol_fct_h1, setRestitution_evol_fct_h1] = useState(null);
    const [restitution_fct_h2, setRestitution_fct_h2] = useState(null);
    const [restitution_evol_fct_h2, setRestitution_evol_fct_h2] = useState(null);
    const [restitution_fct_h3, setRestitution_fct_h3] = useState(null);
    const [restitution_evol_fct_h3, setRestitution_evol_fct_h3] = useState(null);
    const [restitution_inv_h1, setRestitution_inv_h1] = useState(null);
    const [restitution_inv_h2, setRestitution_inv_h2] = useState(null);
    const [restitution_inv_h3, setRestitution_inv_h3] = useState(null);
    const [fiscalite_retro, setFiscalite_retro] = useState(null);
    const [fiscalite_prosp_h1, setFiscalite_prosp_h1] = useState(null);
    const [fiscalite_prosp_h2, setFiscalite_prosp_h2] = useState(null);
    const [fiscalite_prosp_h3, setFiscalite_prosp_h3] = useState(null);
    const [restitutionRetroFct, setRestitutionRetroFct] = useState(null);
    const [restitutionEvolRetroFct, setRestitutionEvolRetroFct] = useState(null);
    const [restitutionRetroInv, setRestitutionRetroInv] = useState(null);
    const [logoOrganisme, setLogoOrganisme] = useState(null);
    const [showButtonScrollUp, setShowButtonScrollUp] = useState(false);
    const width = (window.innerWidth * 0.7);
    const height = (width * (210 / 297));

    // Déclarer les refs
    const elementRef1 = useRef(null);
    const elementRef2 = useRef(null);
    const elementRef3 = useRef(null);
    const elementRef4 = useRef(null);
    const elementRef4b = useRef(null);
    const elementRef5 = useRef(null);
    const elementRef6 = useRef(null);
    const elementRef7 = useRef(null);
    const elementRef8 = useRef(null);
    const elementRef9 = useRef(null);
    const elementRef10 = useRef(null);
    const elementRef11 = useRef(null);
    const elementRef12 = useRef(null);
    const elementRef13 = useRef(null);
    const elementRef14 = useRef(null);
    const elementRef15 = useRef(null);
    const elementRef16 = useRef(null);
    const elementRef17 = useRef(null);
    const elementRef18 = useRef(null);
    const elementRef19 = useRef(null);
    const elementRef20 = useRef(null);
    const elementRef21 = useRef(null);
    const elementRef22 = useRef(null);
    const elementRef23 = useRef(null);
    const elementRef24 = useRef(null);
    const elementRef25 = useRef(null);
    const elementRef26 = useRef(null);
    const elementRef33 = useRef(null);
    const elementRef34 = useRef(null);
    const elementRef35 = useRef(null);
    const elementRef35b = useRef(null);
    const elementRef36 = useRef(null);
    const elementRef37 = useRef(null);
    const elementRef38 = useRef(null);
    const elementRef39 = useRef(null);
    const elementRef39b = useRef(null);
    const elementRef40 = useRef(null);
    const elementRef41 = useRef(null);
    const elementRef42 = useRef(null);
    const elementRef43 = useRef(null);
    const elementRef43b = useRef(null);
    const elementRef44 = useRef(null);
    const elementRef45 = useRef(null);
    const elementRef46 = useRef(null);
    const elementRef47 = useRef(null);
    const elementRef48 = useRef(null);
    const elementRef49 = useRef(null);
    const elementRef50 = useRef(null);
    const elementRef51 = useRef(null);
    const elementRef52 = useRef(null);
    const elementRef53 = useRef(null);
    const elementRef54 = useRef(null);
    const elementRef55 = useRef(null);
    const elementRef56 = useRef(null);
    const elementRef57 = useRef(null);
    const elementRef58 = useRef(null);
    const elementRef59 = useRef(null);
    const elementRef60 = useRef(null);
    const elementRef61 = useRef(null);
    
    // Mapping des pages avec leurs conditions d'affichage
    const pagesMap = {
        1: { ref: elementRef1, display: true },
        2: { ref: elementRef2, display: true },
        3: { ref: elementRef3, display: () => affRetro },
        4: { ref: elementRef4, display: () => affRetro },
        '4b': { ref: elementRef4b, display: () => affRetro },
        5: { ref: elementRef5, display: () => affRetro && props.user.nomen != 'M4' && props.user.nomen != 'M41' && props.user.nomen != 'M43' && props.user.nomen != 'M49' },
        6: { ref: elementRef6, display: () => affRetro && props.user.nomen != 'M4' && props.user.nomen != 'M41' && props.user.nomen != 'M43' && props.user.nomen != 'M49' },
        7: { ref: elementRef7, display: () => affRetro && props.user.nomen != 'M4' && props.user.nomen != 'M41' && props.user.nomen != 'M43' && props.user.nomen != 'M49' },
        8: { ref: elementRef8, display: () => affRetro && props.user.nomen != 'M4' && props.user.nomen != 'M41' && props.user.nomen != 'M43' && props.user.nomen != 'M49' },
        9: { ref: elementRef9, display: () => affRetro },
        10: { ref: elementRef10, display: () => affRetro },
        11: { ref: elementRef11, display: () => affRetro },
        12: { ref: elementRef12, display: () => affRetro && props.user.nomen != 'M4' && props.user.nomen != 'M41' && props.user.nomen != 'M43' && props.user.nomen != 'M49' },
        13: { ref: elementRef13, display: () => affRetro },
        14: { ref: elementRef14, display: () => affRetro && props.user.nomen != 'M4' && props.user.nomen != 'M41' && props.user.nomen != 'M43' && props.user.nomen != 'M49' },
        15: { ref: elementRef15, display: () => affRetro && props.user.nomen != 'M4' && props.user.nomen != 'M41' && props.user.nomen != 'M43' && props.user.nomen != 'M49' },
        16: { ref: elementRef16, display: () => affRetro && props.user.nomen != 'M4' && props.user.nomen != 'M41' && props.user.nomen != 'M43' && props.user.nomen != 'M49' },
        17: { ref: elementRef17, display: () => affRetro && props.user.nomen != 'M4' && props.user.nomen != 'M41' && props.user.nomen != 'M43' && props.user.nomen != 'M49' },
        18: { ref: elementRef18, display: () => affRetro && props.user.nomen != 'M4' && props.user.nomen != 'M41' && props.user.nomen != 'M43' && props.user.nomen != 'M49' },
        19: { ref: elementRef19, display: () => affRetro && props.user.nomen != 'M4' && props.user.nomen != 'M41' && props.user.nomen != 'M43' && props.user.nomen != 'M49' },
        20: { ref: elementRef20, display: () => affRetro && props.user.nomen != 'M4' && props.user.nomen != 'M41' && props.user.nomen != 'M43' && props.user.nomen != 'M49' },
        21: { ref: elementRef21, display: () => affRetro && props.user.nomen != 'M4' && props.user.nomen != 'M41' && props.user.nomen != 'M43' && props.user.nomen != 'M49' },
        22: { ref: elementRef22, display: () => affRetro },
        23: { ref: elementRef23, display: () => affRetro },
        24: { ref: elementRef24, display: () => affRetro },
        25: { ref: elementRef25, display: () => affRetro },
        26: { ref: elementRef26, display: () => affRetro },
        33: { ref: elementRef33, display: () => affProsp },
        34: { ref: elementRef34, display: () => affProsp && affH1 },
        35: { ref: elementRef35, display: () => affProsp && affH1 },
        '35b': { ref: elementRef35b, display: () => affProsp && affH1 },
        36: { ref: elementRef36, display: () => affProsp && affH1 },
        37: { ref: elementRef37, display: () => affProsp && affH1 && props.user.nomen != 'M4' && props.user.nomen != 'M41' && props.user.nomen != 'M43' && props.user.nomen != 'M49' },
        38: { ref: elementRef38, display: () => affProsp && affH2 },
        39: { ref: elementRef39, display: () => affProsp && affH2 },
        '39b': { ref: elementRef39b, display: () => affProsp && affH2 },
        40: { ref: elementRef40, display: () => affProsp && affH2 },
        41: { ref: elementRef41, display: () => affProsp && affH2 && props.user.nomen != 'M4' && props.user.nomen != 'M41' && props.user.nomen != 'M43' && props.user.nomen != 'M49' },
        42: { ref: elementRef42, display: () => affProsp && affH3 },
        43: { ref: elementRef43, display: () => affProsp && affH3 },
        '43b': { ref: elementRef43b, display: () => affProsp && affH3 },
        44: { ref: elementRef44, display: () => affProsp && affH3 },
        45: { ref: elementRef45, display: () => affProsp && affH3 && props.user.nomen != 'M4' && props.user.nomen != 'M41' && props.user.nomen != 'M43' && props.user.nomen != 'M49' },
        46: { ref: elementRef46, display: () => affProsp },
        47: { ref: elementRef47, display: () => affProsp && props.user.nomen != 'M4' && props.user.nomen != 'M41' && props.user.nomen != 'M43' && props.user.nomen != 'M49' },
        48: { ref: elementRef48, display: () => affProsp && props.user.nomen != 'M4' && props.user.nomen != 'M41' && props.user.nomen != 'M43' && props.user.nomen != 'M49' },
        49: { ref: elementRef49, display: () => affProsp && props.user.nomen != 'M4' && props.user.nomen != 'M41' && props.user.nomen != 'M43' && props.user.nomen != 'M49' },
        50: { ref: elementRef50, display: () => affProsp && props.user.nomen != 'M4' && props.user.nomen != 'M41' && props.user.nomen != 'M43' && props.user.nomen != 'M49' },
        51: { ref: elementRef51, display: () => affProsp },
        52: { ref: elementRef52, display: () => affProsp },
        53: { ref: elementRef53, display: () => affProsp },
    };


    async function mount()
    {
        const params = {
            'getOrganismes': true,
            'id': props.user.id_organisme
        }
        await axios.post('https://app-slfinance.fr/api/organismes.php', qs.stringify(params))
        .then(async (res) => {
            await setLogoOrganisme(res.data[0].logo);
        })
        .catch((err) => {
            console.warn(err)
        });

        var ComEpci = "Epfl";

        /* Récupération des annees retro et prosp */
        const annees_retro = await getyears(props.user.id_budget, 'R');
        const annees_prosp_full = await getyears(props.user.id_budget, 'P');
        const annees_prosp = annees_prosp_full.slice(0, 9);

        await setYearsRetro(annees_retro);
        await setYearsProsp(annees_prosp);

        // Récupérer toutes les données en parallèle
        const promises = [];

        // Rétrospective - Fonctionnement
        promises.push(
            axios.post('https://app-slfinance.fr/api/restitution.php', qs.stringify({
                'getRestitution': true,
                'grille': 'EpflRetroFct',
                'annees': annees_retro,
                'id_budget': props.user.id_budget,
                'id_organisme': props.user.id_organisme,
                'hypothese': 'R'
            }))
            .then(ret => {
                setRestitutionRetroFct(ret.data);
                var tmp = [];
                ret.data.forEach((element, i) => {
                    element.forEach((elem, j) => {
                        if (j === 0) {
                            tmp[i] = [];
                            tmp[i].push(elem);
                        }
                        if (j > 1) {
                            tmp[i].push([ret.data[i][j][0], ret.data[i][j-1][1]!==0?((ret.data[i][j][1] - ret.data[i][j-1][1]) / ret.data[i][j-1][1] * 100):0]);
                        }
                    });
                });
                setRestitutionEvolRetroFct(tmp);
            })
        );

        // Rétrospective - Investissement
        promises.push(
            axios.post('https://app-slfinance.fr/api/restitution.php', qs.stringify({
                'getRestitution': true,
                'grille': 'EpflRetroInv',
                'annees': annees_retro,
                'id_budget': props.user.id_budget,
                'id_organisme': props.user.id_organisme,
                'hypothese': 'R'
            }))
            .then(ret => {
                setRestitutionRetroInv(ret.data);
            })
        );

        // Incidences financières H1, H2, H3
        promises.push(
            axios.post('https://app-slfinance.fr/api/incidences_financieres.php', qs.stringify({
                'getSumIncidencesFinancieres': true,
                'annees': annees_prosp,
                'id_budget': props.user.id_budget,
                'hypothese': 'h1'
            }))
            .then(res => {
                var total = [];
                res.data.forEach((element, i) => {
                    total[i] = 0;
                    element.forEach((elem, j) => {
                        if (j > 0) {
                            elem[1] = parseFloat(elem[1]);
                            total[i] += (elem[1]);
                        }
                    });
                });
                res.data.forEach((line, k) => {
                    res.data[k].push(['Total', total[k]])
                });
                setIncid_fin_h1(res.data)
            })
        );

        promises.push(
            axios.post('https://app-slfinance.fr/api/incidences_financieres.php', qs.stringify({
                'getSumIncidencesFinancieres': true,
                'annees': annees_prosp,
                'id_budget': props.user.id_budget,
                'hypothese': 'h2'
            }))
            .then(res => {
                var total = [];
                res.data.forEach((element, i) => {
                    total[i] = 0;
                    element.forEach((elem, j) => {
                        if (j > 0) {
                            elem[1] = parseFloat(elem[1]);
                            total[i] += (elem[1]);
                        }
                    });
                });
                res.data.forEach((line, k) => {
                    res.data[k].push(['Total', total[k]])
                });
                setIncid_fin_h2(res.data)
            })
        );

        promises.push(
            axios.post('https://app-slfinance.fr/api/incidences_financieres.php', qs.stringify({
                'getSumIncidencesFinancieres': true,
                'annees': annees_prosp,
                'id_budget': props.user.id_budget,
                'hypothese': 'h3'
            }))
            .then(res => {
                var total = [];
                res.data.forEach((element, i) => {
                    total[i] = 0;
                    element.forEach((elem, j) => {
                        if (j > 0) {
                            elem[1] = parseFloat(elem[1]);
                            total[i] += (elem[1]);
                        }
                    });
                });
                res.data.forEach((line, k) => {
                    res.data[k].push(['Total', total[k]])
                });
                setIncid_fin_h3(res.data)
            })
        );

        // Restitution Prospective - Fonctionnement H1, H2, H3
        promises.push(
            axios.post('https://app-slfinance.fr/api/datas_restitution.php', qs.stringify({
                'getDataRestitution': true,
                'grille': 'EpflProspFct',
                'annees': annees_prosp,
                'id_budget': props.user.id_budget,
                'hypothese': 'h1'
            }))
            .then(ret => {
                setRestitution_fct_h1(ret.data)
                var tmp = [];
                ret.data.forEach((element, i) => {
                    element.forEach((elem, j) => {
                        if (j === 0) {
                            tmp[i] = [];
                            tmp[i].push(elem);
                        }
                        if (j > 1) {
                            tmp[i].push([ret.data[i][j][0], ret.data[i][j-1][1]!==0?((ret.data[i][j][1] - ret.data[i][j-1][1]) / ret.data[i][j-1][1] * 100):0]);
                        }
                    });
                });
                setRestitution_evol_fct_h1(tmp);
            })
        );

        promises.push(
            axios.post('https://app-slfinance.fr/api/datas_restitution.php', qs.stringify({
                'getDataRestitution': true,
                'grille': 'EpflProspFct',
                'annees': annees_prosp,
                'id_budget': props.user.id_budget,
                'hypothese': 'h2'
            }))
            .then(ret => {
                setRestitution_fct_h2(ret.data)
                var tmp = [];
                ret.data.forEach((element, i) => {
                    element.forEach((elem, j) => {
                        if (j === 0) {
                            tmp[i] = [];
                            tmp[i].push(elem);
                        }
                        if (j > 1) {
                            tmp[i].push([ret.data[i][j][0], ret.data[i][j-1][1]!==0?((ret.data[i][j][1] - ret.data[i][j-1][1]) / ret.data[i][j-1][1] * 100):0]);
                        }
                    });
                });
                setRestitution_evol_fct_h2(tmp);
            })
        );

        promises.push(
            axios.post('https://app-slfinance.fr/api/datas_restitution.php', qs.stringify({
                'getDataRestitution': true,
                'grille': 'EpflProspFct',
                'annees': annees_prosp,
                'id_budget': props.user.id_budget,
                'hypothese': 'h3'
            }))
            .then(ret => {
                setRestitution_fct_h3(ret.data)
                var tmp = [];
                ret.data.forEach((element, i) => {
                    element.forEach((elem, j) => {
                        if (j === 0) {
                            tmp[i] = [];
                            tmp[i].push(elem);
                        }
                        if (j > 1) {
                            tmp[i].push([ret.data[i][j][0], ret.data[i][j-1][1]!==0?((ret.data[i][j][1] - ret.data[i][j-1][1]) / ret.data[i][j-1][1] * 100):0]);
                        }
                    });
                });
                setRestitution_evol_fct_h3(tmp);
            })
        );

        // Restitution Prospective - Investissement H1, H2, H3
        promises.push(
            axios.post('https://app-slfinance.fr/api/datas_restitution.php', qs.stringify({
                'getDataRestitution': true,
                'grille': 'EpflProspInv',
                'annees': annees_prosp,
                'id_budget': props.user.id_budget,
                'hypothese': 'h1'
            }))
            .then(ret => {
                setRestitution_inv_h1(ret.data)
            })
        );

        promises.push(
            axios.post('https://app-slfinance.fr/api/datas_restitution.php', qs.stringify({
                'getDataRestitution': true,
                'grille': 'EpflProspInv',
                'annees': annees_prosp,
                'id_budget': props.user.id_budget,
                'hypothese': 'h2'
            }))
            .then(ret => {
                setRestitution_inv_h2(ret.data)
            })
        );

        promises.push(
            axios.post('https://app-slfinance.fr/api/datas_restitution.php', qs.stringify({
                'getDataRestitution': true,
                'grille': 'EpflProspInv',
                'annees': annees_prosp,
                'id_budget': props.user.id_budget,
                'hypothese': 'h3'
            }))
            .then(ret => {
                setRestitution_inv_h3(ret.data)
            })
        );

        // Fiscalité Prospective H1, H2, H3
        if (props.user.budget_annexe == 0) {
            promises.push(
                axios.post('https://app-slfinance.fr/api/datas_rei.php', qs.stringify({
                    'getGrilleSaisieProspFisc': true,
                    'id_budget': props.user.id_budget,
                    'hypothese': 'h1',
                    'an_deb': annees_prosp[0],
                    'an_fin': annees_prosp[annees_prosp.length-1]
                }))
                .then(ret => {
                    setFiscalite_prosp_h1(ret.data)
                })
            );

            promises.push(
                axios.post('https://app-slfinance.fr/api/datas_rei.php', qs.stringify({
                    'getGrilleSaisieProspFisc': true,
                    'id_budget': props.user.id_budget,
                    'hypothese': 'h2',
                    'an_deb': annees_prosp[0],
                    'an_fin': annees_prosp[annees_prosp.length-1]
                }))
                .then(ret => {
                    setFiscalite_prosp_h2(ret.data)
                })
            );

            promises.push(
                axios.post('https://app-slfinance.fr/api/datas_rei.php', qs.stringify({
                    'getGrilleSaisieProspFisc': true,
                    'id_budget': props.user.id_budget,
                    'hypothese': 'h3',
                    'an_deb': annees_prosp[0],
                    'an_fin': annees_prosp[annees_prosp.length-1]
                }))
                .then(ret => {
                    setFiscalite_prosp_h3(ret.data)
                })
            );
        }

        // Hypothèses
        promises.push(
            axios.post('https://app-slfinance.fr/api/hypothese.php', qs.stringify({
                'get': true,
                'id_budget': props.user.id_budget
            }))
            .then(result => {
                if (result.data.length !== 0) {
                    result.data.forEach(element => {
                        if (element[0] === 'h1') {
                            setHypothese1({'num': 1, 'nom': element[1], 'commentaire': element[2]});
                        }
                        if (element[0] === 'h2') {
                            setHypothese2({'num': 2, 'nom': element[1], 'commentaire': element[2]});
                        }
                        if (element[0] === 'h3') {
                            setHypothese3({'num': 3, 'nom': element[1], 'commentaire': element[2]});
                        }
                    });
                }
            })
        );

        // Exécuter toutes les requêtes en parallèle
        await Promise.all(promises);
        await setPDFREADY(true);
        await setAff(!aff);
    }


    useEffect(() => {
        if (props.user === null) {
            props.getUser();
        }
        else {
            mount();
        }
        
        const handleScroll = () => {
            if (window.scrollY > 500) {
                setShowButtonScrollUp(true);
            } else {
                setShowButtonScrollUp(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);

    }, [props.user])


        const downloadPDFFile = async(imagesData) => {
        try {
            const pdfFileName = `Bilan_Financier_${day}-${month}-${date.getFullYear()}.pdf`;
            
            // Construire dynamiquement le PDF avec seulement les pages affichées
            const PDFDocument = (
                <Document title={pdfFileName}>
                    {imagesData.map((img) => (
                        img && <Page key={img.pageId} size="A4" orientation="landscape">
                            <Image src={img.data} style={{width: '100%', height: '100%'}} />
                        </Page>
                    ))}
                </Document>
            );
            
            // Générer le PDF et télécharger
            const pdfBlob = await pdf(PDFDocument).toBlob();
            const url = URL.createObjectURL(pdfBlob);
            const link = document.createElement('a');
            link.href = url;
            link.download = pdfFileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);
            
            console.log('PDF téléchargé avec succès:', pdfFileName);
        } catch (error) {
            console.error('Erreur lors du téléchargement du PDF:', error);
            alert('Erreur lors de la création du PDF: ' + error.message);
        }
    };

    const htmlToImageConvert = async() => {
        const imagesData = [];
        
        // Convertir toutes les pages affichées en images PNG
        for (const [pageId, pageData] of Object.entries(pagesMap)) {
            const shouldDisplay = typeof pageData.display === 'function' ? pageData.display() : pageData.display;
            
            if (shouldDisplay && pageData.ref.current) {
                try {
                    const dataUrl = await toPng(pageData.ref.current, { cacheBust: false });
                    imagesData.push({
                        pageId: pageId,
                        data: dataUrl
                    });
                } catch (error) {
                    console.error(`Erreur lors de la conversion de la page ${pageId}:`, error);
                }
            }
        }
        
        // Télécharger le PDF avec les images récupérées
        await downloadPDFFile(imagesData);
        await setClicked(false);
        await setAff(!aff);
    };


    return (
    <div style={{flex: 1, position: 'relative'}}>
        <Access needConnection={true} type_user={[0]}>
            <Navbar />
            
            {showButtonScrollUp && (
            <button
            style={{position: 'fixed', bottom: 20, right: 20, width: (width/10), height: (height/10), border: '1px solid black', borderRadius: 5}}
            onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}>
                <IconScrollUp width={(width/10)}/>
            </button>
            )}

            <div style={{display: 'flex'}}>

                <div style={{flex: 1}}></div>

                <div style={{flex: 1, marginTop: 20, textAlign: 'center'}}>
                    <p style={{color: purple, fontSize: 20}}>Prévisualisation du PDF</p>
                </div>

                <div style={{flex: 1}}></div>
            </div>

            <div style={{flex: 1, display: 'flex'}}>

                <div style={{flex: 1}}></div>
                
                <button
                className='shadow-md rounded-md'
                style={
                    affRetro?
                    {backgroundColor: purple, color: 'white', fontSize: 14, marginTop: 20, marginRight: 20, marginLeft: 20, paddingLeft: 5, paddingRight: 5}
                    :
                    {color: purple, fontSize: 14, marginTop: 20, marginRight: 20, marginLeft: 20, paddingLeft: 5, paddingRight: 5}
                }
                onClick={async() => {
                    await setAffRetro(!affRetro);
                    await setAff(!aff);
                }}>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <p style={{margin: 5}}>Rétrospective</p>
                    </div>
                </button>
                
                <button
                className='shadow-md rounded-md'
                style={
                    affProsp?
                    {backgroundColor: purple, color: 'white', fontSize: 14, marginTop: 20, marginRight: 20, paddingLeft: 5, paddingRight: 5}
                    :
                    {color: purple, fontSize: 14, marginTop: 20, marginRight: 20, paddingLeft: 5, paddingRight: 5}
                }
                onClick={async() => {
                    await setAffProsp(!affProsp);
                }}>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <p style={{margin: 5}}>Prospective</p>
                    </div>
                </button>

                <button
                className='shadow-md rounded-md'
                style={
                    affH1?
                    {backgroundColor: purple, color: 'white', fontSize: 14, marginTop: 20, marginRight: 20, paddingLeft: 5, paddingRight: 5}
                    :
                    {color: purple, fontSize: 14, marginTop: 20, marginRight: 20, paddingLeft: 5, paddingRight: 5}
                }
                onClick={async() => {
                    if (affH1) {
                        await setAffH1(false)
                    }
                    else {
                        await setAffH1(true)
                    }
                    await setAff(!aff);
                }}>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <p style={{margin: 5}}>Hypothèse 1</p>
                    </div>
                </button>

                <button
                className='shadow-md rounded-md'
                style={
                    affH2?
                    {backgroundColor: purple, color: 'white', fontSize: 14, marginTop: 20, marginRight: 20, paddingLeft: 5, paddingRight: 5}
                    :
                    {color: purple, fontSize: 14, marginTop: 20, marginRight: 20, paddingLeft: 5, paddingRight: 5}
                }
                onClick={async() => {
                    if (affH2) {
                        await setAffH2(false)
                    }
                    else {
                        await setAffH2(true)
                    }
                    await setAff(!aff);
                }}>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <p style={{margin: 5}}>Hypothèse 2</p>
                    </div>
                </button>

                <button
                className='shadow-md rounded-md'
                style={
                    affH3?
                    {backgroundColor: purple, color: 'white', fontSize: 14, marginTop: 20, marginRight: 20, paddingLeft: 5, paddingRight: 5}
                    :
                    {color: purple, fontSize: 14, marginTop: 20, marginRight: 20, paddingLeft: 5, paddingRight: 5}
                }
                onClick={async() => {
                    if (affH3) {
                        await setAffH3(false)
                    }
                    else {
                        await setAffH3(true)
                    }
                    await setAff(!aff);
                }}>
                    <div style={{display: 'flex', alignItems: 'center'}}>
                        <p style={{margin: 5}}>Hypothèse 3</p>
                    </div>
                </button>

                <div style={{flex: 1, display: 'flex', justifyContent: 'flex-end'}}>
                    {!clicked && <button
                    className='shadow-md rounded-md'
                    style={{backgroundColor: green, color: 'white', fontSize: 14, marginTop: 20, marginRight: 20, paddingLeft: 5, paddingRight: 5, opacity: !PDFREADY ? 0.6 : 1, cursor: !PDFREADY ? 'not-allowed' : 'pointer'}}
                    onClick={async() => {
                        if (props.user && PDFREADY) {
                            await setClicked(true);
                            await htmlToImageConvert();
                        }
                    }}
                    disabled={!PDFREADY}
                    >
                        <div style={{display: 'flex', alignItems: 'center'}}>
                            <IconPdfWhite width="18"/>
                            <p style={{margin: 5}}>{!PDFREADY ? 'Récupération des données' : 'Créer le PDF'}</p>
                        </div>
                    </button>}
                </div>
                
                
            </div>

            {props.user !== null && yearsRetro !== null && yearsProsp !== null && incid_fin_h1 !== null && incid_fin_h2 !== null && incid_fin_h3 !== null?
                <div style={{flex: 1, justifyContent: 'center', alignItems: 'center'}}>

                
                {/* PARTIE PRÉVISUALISATION */}
                <div style={{display: 'flex'}}>
                    <div style={{flex: 0.15}}></div>
                    <div style={{flex: 1}}>

                        <div style={{flex: 1, margin: 25, display: 'flex'}}>
                            <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef1}>
                                <Page1Accueil user={props.user} yearsRetro={yearsRetro} date={dateFR} logoOrganisme={logoOrganisme} />
                            </div>
                        </div>
                                            
                        <div style={{flex: 1, margin: 25, display: 'flex'}}>
                            <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef2}>
                                <Page2Sommaire user={props.user} titre={'Sommaire'} date={dateFR} index={''} affRetro={affRetro} affProsp={affProsp} affH1={affH1} affH2={affH2} affH3={affH3} NBFP={''} />
                            </div>
                        </div>

                        {affRetro?
                        <div>
                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef3}>
                                    <Page3Fct user={props.user} date={dateFR} index={''} />
                                </div>
                            </div>

                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef4}>
                                    <Page4RestitutionFct user={props.user} annees={yearsRetro} date={dateFR} restitution={restitutionRetroFct} titre={'Équilibre d\'exploitation'} index={''} />
                                </div>
                            </div>

                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef4b}>
                                    <Page4RestitutionFct user={props.user} annees={yearsRetro} date={dateFR} restitution={restitutionEvolRetroFct} titre={'Évolution ' + (props.user.nomen == 'M4' || props.user.nomen == 'M41' || props.user.nomen == 'M43' || props.user.nomen == 'M49'?'d\'exploitation':'du fonctionnement')} index={''} evolution={true} />
                                </div>
                            </div>


                            {props.user.nomen != 'M4' && props.user.nomen != 'M41' && props.user.nomen != 'M43' && props.user.nomen != 'M49'?
                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef5}>
                                    <Page5Graph user={props.user} annees={yearsRetro} date={dateFR} titre={'Répartition des recettes et dépenses ' + (props.user.nomen == 'M4' || props.user.nomen == 'M41' || props.user.nomen == 'M43' || props.user.nomen == 'M49'?'d\'exploitation':'de fonctionnement')} index={''} />
                                </div>
                            </div>
                            :null}

                            {props.user.nomen != 'M4' && props.user.nomen != 'M41' && props.user.nomen != 'M43' && props.user.nomen != 'M49'?
                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef6}>
                                    <Page6Graph user={props.user} annees={yearsRetro} date={dateFR} titre={'Dynamique générale ' + (props.user.nomen == 'M4' || props.user.nomen == 'M41' || props.user.nomen == 'M43' || props.user.nomen == 'M49'?'d\'exploitation':'du fonctionnement')} index={''} />
                                </div>
                            </div>
                            :null}

                            
                            {props.user.nomen != 'M4' && props.user.nomen != 'M41' && props.user.nomen != 'M43' && props.user.nomen != 'M49'?
                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef7}>
                                    <Page7Graph user={props.user} annees={yearsRetro} date={dateFR} titre={'Structure des recettes de fonctionnement'} index={''} />
                                </div>
                            </div>
                            :null}

                            {props.user.nomen != 'M4' && props.user.nomen != 'M41' && props.user.nomen != 'M43' && props.user.nomen != 'M49'?
                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef8}>
                                    <Page8Graph user={props.user} annees={yearsRetro} date={dateFR} titre={'Structure des dépenses ' + (props.user.nomen == 'M4' || props.user.nomen == 'M41' || props.user.nomen == 'M43' || props.user.nomen == 'M49'?'d\'exploitation':'de fonctionnement')} index={''} />
                                </div>
                            </div>
                            :null}

                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef9}>
                                    <Page9Graph user={props.user} annees={yearsRetro} date={dateFR} titre={'Taux d\'épargne'} index={''} />
                                </div>
                            </div>

                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef10}>
                                    <Page10Inv user={props.user} date={dateFR} index={''} />
                                </div>
                            </div>

                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef11}>
                                    <Page11RestitutionInv user={props.user} annees={yearsRetro} date={dateFR} restitution={restitutionRetroInv} titre={'Financement de l\'investissement'} index={''} />
                                </div>
                            </div>

                            {props.user.nomen != 'M4' && props.user.nomen != 'M41' && props.user.nomen != 'M43' && props.user.nomen != 'M49'?
                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef12}>
                                    <Page12Graph user={props.user} annees={yearsRetro} date={dateFR} titre={'Dynamique d\'investissement'} index={''} />
                                </div>
                            </div>
                            :null}

                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef13}>
                                    <Page13Graph user={props.user} annees={yearsRetro} date={dateFR} titre={'Résultat de clôture et restes à réaliser'} index={''} />
                                </div>
                            </div>

                            {props.user.nomen != 'M4' && props.user.nomen != 'M41' && props.user.nomen != 'M43' && props.user.nomen != 'M49'?
                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef14}>
                                    <Page14Fiscalite user={props.user} date={dateFR} index={''} />
                                </div>
                            </div>
                            :null}

                            {props.user.nomen != 'M4' && props.user.nomen != 'M41' && props.user.nomen != 'M43' && props.user.nomen != 'M49'?
                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef15}>
                                    <Page15FiscaliteRetro user={props.user} annees={yearsRetro} date={dateFR} restitution={fiscalite_retro} titre={'Recettes de fiscalité directe'} index={''} />
                                </div>
                            </div>
                            :null}

                            {props.user.nomen != 'M4' && props.user.nomen != 'M41' && props.user.nomen != 'M43' && props.user.nomen != 'M49'?
                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef16}>
                                    <Page16Graph user={props.user} annees={yearsRetro} date={dateFR} titre={'Niveau des bases d\'imposition'} index={''} />
                                </div>
                            </div>
                            :null}

                            {props.user.nomen != 'M4' && props.user.nomen != 'M41' && props.user.nomen != 'M43' && props.user.nomen != 'M49'?
                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef17}>
                                    <Page17Graph user={props.user} annees={yearsRetro} date={dateFR} titre={'Évolution des bases d\'imposition'} index={''} />
                                </div>
                            </div>
                            :null}

                            {props.user.nomen != 'M4' && props.user.nomen != 'M41' && props.user.nomen != 'M43' && props.user.nomen != 'M49'?
                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef18}>
                                    <Page18Graph user={props.user} annees={yearsRetro} date={dateFR} titre={'Bases d\'imposition par habitant'} index={''} />
                                </div>
                            </div>
                            :null}


                            {props.user.nomen != 'M4' && props.user.nomen != 'M41' && props.user.nomen != 'M43' && props.user.nomen != 'M49'?
                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef19}>
                                    <Page19Graph user={props.user} annees={yearsRetro} date={dateFR} titre={'Niveaux des taux d\'imposition'} index={''} />
                                </div>
                            </div>
                            :null}

                            {props.user.nomen != 'M4' && props.user.nomen != 'M41' && props.user.nomen != 'M43' && props.user.nomen != 'M49'?
                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef20}>
                                    <Page20Graph user={props.user} annees={yearsRetro} date={dateFR} titre={'Évolution des taux d\'imposition'} index={''} />
                                </div>
                            </div>
                            :null}

                            {props.user.nomen != 'M4' && props.user.nomen != 'M41' && props.user.nomen != 'M43' && props.user.nomen != 'M49'?
                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef21}>
                                    <Page21Graph user={props.user} annees={yearsRetro} date={dateFR} titre={'Panier des ressources fiscales'} index={''} />
                                </div>
                            </div>
                            :null}

                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef22}>
                                    <Page22Dette user={props.user} annees={yearsRetro} date={dateFR} index={''} />
                                </div>
                            </div>

                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef24}>
                                    <Page24Graph user={props.user} annees={yearsRetro} date={dateFR} titre={'Encours de la dette au 31/12'} index={''} />
                                </div>
                            </div>

                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef23}>
                                    <Page23Graph user={props.user} annees={yearsRetro} date={dateFR} titre={'Extinction de la dette'} index={''} />
                                </div>
                            </div>

                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef25}>
                                    <Page25Graph user={props.user} annees={yearsRetro} date={dateFR} titre={'Indicateurs d\'endettement'} index={''} />
                                </div>
                            </div>

                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef26}>
                                    <Page26Graph user={props.user} annees={yearsRetro} date={dateFR} titre={'Indicateurs d\'endettement'} index={''} />
                                </div>
                            </div>
                        </div>
                        :null}

                        {affProsp?
                        <div>
                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef33}>
                                    <Page31ProjectionFinanciere user={props.user} date={dateFR} index={''} />
                                </div>
                            </div>

    {/* H1 */}
                            {affH1?
                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef34}>
                                    <Page32ComFP user={props.user} date={dateFR} hypothese={hypothese1} index={''} />
                                </div>
                            </div>
                            :null}

                            {affH1?
                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef35}>
                                    <Page33RestitutionProsp user={props.user} annees={yearsProsp} date={dateFR} restitution={restitution_fct_h1} titre={'Équilibres '+ (props.user.nomen == 'M4' || props.user.nomen == 'M41' || props.user.nomen == 'M43' || props.user.nomen == 'M49'?'d\'exploitation':'du fonctionnement') +' projetés'} hypothese={hypothese1} index={''} />
                                </div>
                            </div>
                            :null}

                            {affH1?
                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef35b}>
                                    <Page33RestitutionProsp user={props.user} annees={yearsProsp} date={dateFR} restitution={restitution_evol_fct_h1} titre={'Évolutions '+ (props.user.nomen == 'M4' || props.user.nomen == 'M41' || props.user.nomen == 'M43' || props.user.nomen == 'M49'?'d\'exploitation':'du fonctionnement') +' projetées'} hypothese={hypothese1} index={''} evolution={true} />
                                </div>
                            </div>
                            :null}

                            {affH1?
                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef36}>
                                    <Page33RestitutionProsp user={props.user} annees={yearsProsp} date={dateFR} restitution={restitution_inv_h1} titre={'Financement des investissements projetés'} hypothese={hypothese1} index={''} />
                                </div>
                            </div>
                            :null}

                            {affH1 && props.user.nomen != 'M4' && props.user.nomen != 'M41' && props.user.nomen != 'M43' && props.user.nomen != 'M49'?
                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef37}>
                                    <Page34FiscaliteProsp user={props.user} annees={yearsProsp} date={dateFR} objet={fiscalite_prosp_h1} titre={'Ressources fiscales projetées'} hypothese={hypothese1} index={''} />
                                </div>
                            </div>
                            :null}

    {/* H2 */}
                            {affH2?
                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef38}>
                                    <Page32ComFP user={props.user} date={dateFR} hypothese={hypothese2} index={''} />
                                </div>
                            </div>
                            :null}

                            {affH2?
                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef39}>
                                    <Page33RestitutionProsp user={props.user} annees={yearsProsp} date={dateFR} restitution={restitution_fct_h2} titre={'Équilibres '+ (props.user.nomen == 'M4' || props.user.nomen == 'M41' || props.user.nomen == 'M43' || props.user.nomen == 'M49'?'d\'exploitation':'du fonctionnement') +' projetés'} hypothese={hypothese2} index={''} />
                                </div>
                            </div>
                            :null}

                            {affH2?
                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef39b}>
                                    <Page33RestitutionProsp user={props.user} annees={yearsProsp} date={dateFR} restitution={restitution_evol_fct_h2} titre={'Évolutions '+ (props.user.nomen == 'M4' || props.user.nomen == 'M41' || props.user.nomen == 'M43' || props.user.nomen == 'M49'?'d\'exploitation':'du fonctionnement') +' projetées'} hypothese={hypothese2} index={''} evolution={true} />
                                </div>
                            </div>
                            :null}

                            {affH2?
                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef40}>
                                    <Page33RestitutionProsp user={props.user} annees={yearsProsp} date={dateFR} restitution={restitution_inv_h2} titre={'Financement des investissements projetés'} hypothese={hypothese2} index={''} />
                                </div>
                            </div>
                            :null}

                            {affH2 && props.user.nomen != 'M4' && props.user.nomen != 'M41' && props.user.nomen != 'M43' && props.user.nomen != 'M49'?
                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef41}>
                                    <Page34FiscaliteProsp user={props.user} annees={yearsProsp} date={dateFR} objet={fiscalite_prosp_h2} titre={'Ressources fiscales projetées'} hypothese={hypothese2} index={''} />
                                </div>
                            </div>
                            :null}

    {/* H3 */}
                            {affH3?
                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef42}>
                                    <Page32ComFP user={props.user} date={dateFR} hypothese={hypothese3} index={''} />
                                </div>
                            </div>
                            :null}

                            {affH3?
                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef43}>
                                    <Page33RestitutionProsp user={props.user} annees={yearsProsp} date={dateFR} restitution={restitution_fct_h3} titre={'Équilibres '+ (props.user.nomen == 'M4' || props.user.nomen == 'M41' || props.user.nomen == 'M43' || props.user.nomen == 'M49'?'d\'exploitation':'du fonctionnement') +' projetés'} hypothese={hypothese3} index={''} />
                                </div>
                            </div>
                            :null}

                            {affH3?
                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef43b}>
                                    <Page33RestitutionProsp user={props.user} annees={yearsProsp} date={dateFR} restitution={restitution_evol_fct_h3} titre={'Évolutions '+ (props.user.nomen == 'M4' || props.user.nomen == 'M41' || props.user.nomen == 'M43' || props.user.nomen == 'M49'?'d\'exploitation':'du fonctionnement') +' projetées'} hypothese={hypothese3} index={''} evolution={true} />
                                </div>
                            </div>
                            :null}

                            {affH3?
                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef44}>
                                    <Page33RestitutionProsp user={props.user} annees={yearsProsp} date={dateFR} restitution={restitution_inv_h3} titre={'Financement des investissements projetés'} hypothese={hypothese3} index={''} />
                                </div>
                            </div>
                            :null}

                            {affH3 && props.user.nomen != 'M4' && props.user.nomen != 'M41' && props.user.nomen != 'M43' && props.user.nomen != 'M49'?
                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef45}>
                                    <Page34FiscaliteProsp user={props.user} annees={yearsProsp} date={dateFR} objet={fiscalite_prosp_h3} titre={'Ressources fiscales projetées'} hypothese={hypothese3} index={''} />
                                </div>
                            </div>
                            :null}

                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef46}>
                                    <Page31ProjectionFinanciere user={props.user} date={dateFR} index={''} />
                                </div>
                            </div>

                            {props.user.nomen != 'M4' && props.user.nomen != 'M41' && props.user.nomen != 'M43' && props.user.nomen != 'M49'?
                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef47}>
                                    <Page35Graph aff={aff} setAff={setAff} affH1={affH1} affH2={affH2} affH3={affH3} user={props.user} annees={yearsProsp} date={dateFR} titre={'Dynamique générale '+ (props.user.nomen == 'M4' || props.user.nomen == 'M41' || props.user.nomen == 'M43' || props.user.nomen == 'M49'?'d\'exploitation':'du fonctionnement')} index={''} />
                                </div>
                            </div>
                            :null}


                            {props.user.nomen != 'M4' && props.user.nomen != 'M41' && props.user.nomen != 'M43' && props.user.nomen != 'M49'?
                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef48}>
                                    <Page36Graph aff={aff} setAff={setAff} affH1={affH1} affH2={affH2} affH3={affH3} user={props.user} annees={yearsProsp} date={dateFR} titre={'Évolution des recettes '+ (props.user.nomen == 'M4' || props.user.nomen == 'M41' || props.user.nomen == 'M43' || props.user.nomen == 'M49'?'d\'exploitation':'de fonctionnement')} index={''} />
                                </div>
                            </div>
                            :null}


                            {props.user.nomen != 'M4' && props.user.nomen != 'M41' && props.user.nomen != 'M43' && props.user.nomen != 'M49'?
                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef49}>
                                    <Page37Graph aff={aff} setAff={setAff} affH1={affH1} affH2={affH2} affH3={affH3} user={props.user} annees={yearsProsp} date={dateFR} titre={'Évolution des dépenses '+ (props.user.nomen == 'M4' || props.user.nomen == 'M41' || props.user.nomen == 'M43' || props.user.nomen == 'M49'?'d\'exploitation':'de fonctionnement')} index={''} />
                                </div>
                            </div>
                            :null}


                            {props.user.nomen != 'M4' && props.user.nomen != 'M41' && props.user.nomen != 'M43' && props.user.nomen != 'M49'?
                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef50}>
                                    <Page38Graph aff={aff} setAff={setAff} affH1={affH1} affH2={affH2} affH3={affH3} user={props.user} annees={yearsProsp} date={dateFR} titre={'Indicateurs complémentaires de la section '+ (props.user.nomen == 'M4' || props.user.nomen == 'M41' || props.user.nomen == 'M43' || props.user.nomen == 'M49'?'exploitation':'fonctionnement')} index={''} />
                                </div>
                            </div>
                            :null}

                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef51}>
                                    <Page39Graph aff={aff} setAff={setAff} affH1={affH1} affH2={affH2} affH3={affH3} user={props.user} annees={yearsProsp} date={dateFR} titre={'Taux d\'épargne'} index={''} />
                                </div>
                            </div>

                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef52}>
                                    <Page40Graph aff={aff} setAff={setAff} affH1={affH1} affH2={affH2} affH3={affH3} user={props.user} annees={yearsProsp} date={dateFR} titre={'Endettement projeté'} index={''} />
                                </div>
                            </div>

                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef53}>
                                    <Page41Graph aff={aff} setAff={setAff} affH1={affH1} affH2={affH2} affH3={affH3} user={props.user} annees={yearsProsp} date={dateFR} titre={'Financement de l\'investissement'} index={''} />
                                </div>
                            </div>

                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef54}>
                                    <Page42Graph aff={aff} setAff={setAff} affH1={affH1} affH2={affH2} affH3={affH3} user={props.user} annees={yearsProsp} date={dateFR} titre={'Principales recettes d\'exploitation'} index={''} />
                                </div>
                            </div>

                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef55}>
                                    <Page43Graph aff={aff} setAff={setAff} affH1={affH1} affH2={affH2} affH3={affH3} user={props.user} annees={yearsProsp} date={dateFR} titre={'Charges d\'exploitation'} index={''} />
                                </div>
                            </div>

                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef56}>
                                    <Page44Graph aff={aff} setAff={setAff} affH1={affH1} affH2={affH2} affH3={affH3} user={props.user} annees={yearsProsp} date={dateFR} titre={'Couverture des charges de personnel par les frais facturés'} index={''} />
                                </div>
                            </div>

                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef57}>
                                    <Page45Graph aff={aff} setAff={setAff} affH1={affH1} affH2={affH2} affH3={affH3} user={props.user} annees={yearsProsp} date={dateFR} titre={'Acquisitions globales'} index={''} />
                                </div>
                            </div>

                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef58}>
                                    <Page46Graph aff={aff} setAff={setAff} affH1={affH1} affH2={affH2} affH3={affH3} user={props.user} annees={yearsProsp} date={dateFR} titre={'Plan pluriannuel d\'investissement (PPI)'} index={''} />
                                </div>
                            </div>

                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef59}>
                                    <Page47Graph aff={aff} setAff={setAff} affH1={affH1} affH2={affH2} affH3={affH3} user={props.user} annees={yearsProsp} date={dateFR} titre={'Évolution du portefeuille porté'} index={''} />
                                </div>
                            </div>

                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef60}>
                                    <Page48Graph aff={aff} setAff={setAff} affH1={affH1} affH2={affH2} affH3={affH3} user={props.user} annees={yearsProsp} date={dateFR} titre={'Endettement / portage'} index={''} />
                                </div>
                            </div>

                            <div style={{flex: 1, margin: 25, display: 'flex'}}>
                                <div className='shadow-md p-2 rounded-md' style={{flex: 1, backgroundColor: 'white', height: 800}} ref={elementRef61}>
                                    <Page49Graph aff={aff} setAff={setAff} affH1={affH1} affH2={affH2} affH3={affH3} user={props.user} annees={yearsProsp} date={dateFR} titre={'Annuités collectivités et amortissement de la dette'} index={''} />
                                </div>
                            </div>
                        </div>
                        :null}
                    </div>

                    <div style={{flex: 0.15}}></div>
                    
                </div>
            </div>
            :
            <div style={{flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', margin: 100}}>
                <BounceLoader color={purple} />
            </div>}
        </Access>
    </div>
    );
}

export default BilanPDF;
